var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Single-line item")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }